import { pddRoot } from "../../utils/defaultValues";
import { globalRoot } from "../../utils/defaultValues";
import ListIcon from "@mui/icons-material/List";
import ApartmentIcon from "@mui/icons-material/Apartment";
import GridViewIcon from "@mui/icons-material/GridView";
import FlagIcon from "@mui/icons-material/Flag";
import SettingsIcon from "@mui/icons-material/Settings";
import RequestQuoteIcon from "@mui/icons-material/RequestQuote";
import GradingIcon from "@mui/icons-material/Grading";
import AutoStoriesIcon from "@mui/icons-material/AutoStories";
import ConstructionIcon from "@mui/icons-material/Construction";
import LinkedCameraIcon from "@mui/icons-material/LinkedCamera";
import RoomPreferencesIcon from "@mui/icons-material/RoomPreferences";
import EngineeringIcon from "@mui/icons-material/Engineering";
import PostAddIcon from "@mui/icons-material/PostAdd";
import DonutLargeIcon from '@mui/icons-material/DonutLarge';

export const projectScopeNav = [];

export const nav = [
  {
    id: "pdd-project-list",
    icon: (
      <ListIcon
        style={{ marginLeft: 5, width: 22, height: 22, color: "#244a9a" }}
      />
    ),
    label: "menu.project-list",
    to: `${pddRoot}/project-list`,
    roles: [],
    renderScope: true,
    defaultAccess: true,
    parentId: "pdd-management",
  },
  // {
  //   id: "pdd-data-analysis",
  //   icon: <DonutLargeIcon style={{ width:22, height:22, color: "#637381"}} />,
  //   label: "menu.data-analysis",
  //   to: `${pddRoot}/data-analysis`,
  //   roles: [],
  //   renderScope: true,
  //   defaultAccess: true,
  //   parentId: "pdd-management",
  // },
  {
    id: "pdd-overview-tag",
    label: "tag.overview",
    tag: true,
    roles: [],
    renderScope: false,
    defaultAccess: true,
    renderScopeCondition: {
      serviceLine: "pdd",
      key: "isProjectScope",
    },
    parentId: "pdd-management",
  },
  {
    id: "pdd-project-dashboard",
    label: "menu.project-dashboard",
    to: `${pddRoot}/project/project-dashboard`,
    icon: (
      <GridViewIcon
        style={{ marginLeft: 5, width: 22, height: 22, color: "#244a9a" }}
      />
    ),
    roles: [],
    renderScope: false,
    defaultAccess: true,
    renderScopeCondition: {
      serviceLine: "pdd",
      key: "isProjectScope",
    },
    parentId: "pdd-management",
  },
  {
    id: "pdd-assets-overview",
    label: "menu.asset-overview",
    to: `${pddRoot}/project/assets-overview`,
    icon: (
      <ApartmentIcon
        style={{ marginLeft: 5, width: 22, height: 22, color: "#244a9a" }}
      />
    ),
    roles: [],
    renderScope: false,
    defaultAccess: true,
    renderScopeCondition: {
      serviceLine: "pdd",
      key: "isProjectScope",
    },
    parentId: "pdd-management",
  },
  {
    id: "pdd-building-profile",
    label: "menu.building-profile",
    to: `${pddRoot}/project/building-profile`,
    icon: (
      <RoomPreferencesIcon
        style={{ marginLeft: 5, width: 22, height: 22, color: "#244a9a" }}
      />
    ),
    roles: [],
    renderScope: false,
    defaultAccess: true,
    renderScopeCondition: {
      serviceLine: "pdd",
      key: "isProjectScope",
    },
    parentId: "pdd-management",
  },
  // Removed for PDD: defects, capex-overview, red-flag, statutory-compliance
  // {
  //   id: "pdd-project-defects",
  //   label: "menu.defects",
  //   to: `${pddRoot}/project/defects`,
  //   icon: (
  //     <ConstructionIcon
  //       style={{ marginLeft: 5, width: 22, height: 22, color: "#244a9a" }}
  //     />
  //   ),
  //   roles: [],
  //   renderScope: false,
  //   defaultAccess: true,
  //   renderScopeCondition: {
  //     serviceLine: "pdd",
  //     key: "isProjectScope",
  //   },
  //   parentId: "pdd-management",
  // },
  {
    id: "pdd-photo-documentation",
    label: "menu.photo-documentation",
    to: `${pddRoot}/project/photo-documentation`,
    icon: (
      <LinkedCameraIcon
        style={{ marginLeft: 5, width: 22, height: 22, color: "#244a9a" }}
      />
    ),
    roles: [],
    renderScope: false,
    defaultAccess: true,
    renderScopeCondition: {
      serviceLine: "pdd",
      key: "isProjectScope",
    },
    parentId: "pdd-management",
  },
  // Removed for PDD: capex-overview
  // {
  //   id: "pdd-capex-overview",
  //   label: "menu.capexOverview",
  //   to: `${pddRoot}/project/capex-overview`,
  //   icon: (
  //     <RequestQuoteIcon
  //       style={{ marginLeft: 5, width: 22, height: 22, color: "#244a9a" }}
  //     />
  //   ),
  //   roles: [],
  //   renderScope: false,
  //   defaultAccess: true,
  //   renderScopeCondition: {
  //     serviceLine: "pdd",
  //     key: "isProjectScope",
  //   },
  //   parentId: "pdd-management",
  // },
  // Removed for PDD: red-flag
  // {
  //   id: "pdd-red-flag",
  //   label: "menu.redFlag",
  //   to: `${pddRoot}/project/red-flag`,
  //   icon: (
  //     <FlagIcon
  //       style={{ marginLeft: 5, width: 22, height: 22, color: "#244a9a" }}
  //     />
  //   ),
  //   roles: [],
  //   renderScope: false,
  //   defaultAccess: true,
  //   renderScopeCondition: {
  //     serviceLine: "pdd",
  //     key: "isProjectScope",
  //   },
  //   parentId: "pdd-management",
  // },
  {
    id: "pdd-full-report",
    label: "menu.fullReport",
    to: `${pddRoot}/project/full-report`,
    icon: (
      <AutoStoriesIcon
        style={{ marginLeft: 5, width: 22, height: 22, color: "#244a9a" }}
      />
    ),
    roles: [],
    renderScope: false,
    defaultAccess: true,
    renderScopeCondition: {
      serviceLine: "pdd",
      key: "isProjectScope",
    },
    parentId: "pdd-management",
  },
  // Removed for PDD: statutory-compliance
  // {
  //   id: "pdd-statutory-compliance",
  //   label: "menu.statutoryCompliance",
  //   to: `${pddRoot}/project/statutory-compliance`,
  //   icon: (
  //     <GradingIcon
  //       style={{ marginLeft: 5, width: 22, height: 22, color: "#244a9a" }}
  //     />
  //   ),
  //   roles: [],
  //   defaultAccess: true,
  //   renderScope: false,
  //   renderScopeCondition: {
  //     serviceLine: "pdd",
  //     key: "isProjectScope",
  //   },
  //   parentId: "pdd-management",
  // },
  {
    id: "pdd-custom-report",
    label: "menu.customReport",
    defaultAccess: false,
    to: `${pddRoot}/project/custom-report`,
    icon: (
      <PostAddIcon
        style={{ marginLeft: 5, width: 22, height: 22, color: "#244a9a" }}
      />
    ),
    roles: [],
    renderScope: false,
    renderScopeCondition: {
      serviceLine: "pdd",
      key: "isProjectScope",
    },
    parentId: "pdd-management",
  },
];
